import Vue from "vue";

class VueApps {
  static init() {
    const masterList = document.getElementById("vue-masterlist");
    Vue.component("MasterList", () => import("./App/MasterListApp.vue"));

    if (masterList) {
      // eslint-disable-next-line
      new Vue({
        el: masterList,
      });
    }
  }
}
export default VueApps;
